// assets/br-product.js
// BR_Custom Zoom : version du JS (à taper dans la console pour vérifier : BR_ZOOM_VERSION)
window.BR_ZOOM_VERSION = "dialog-2";

// BR_Custom Image Zoom Box : lié dès le chargement du script (avant même le "ready"),
// pour ne pas dépendre des autres initialisations
BRSafeInit(InitBRImageZooms);

$(document).ready(function () {
  // Chaque init est isolée : si l'une plante, les suivantes démarrent quand même
  BRSafeInit(InitKlaviyo);
  BRSafeInit(OpenFirstProductTab);
  // BR_Custom Color Swatches Names
  BRSafeInit(InitLinkedColorSwatches);
  // BR_Custom Carrousel Medias
  BRSafeInit(InitBRProductGalleries);
  // BR_Custom Image Zoom Box (sans risque : InitBRImageZooms peut être appelée plusieurs fois)
  BRSafeInit(InitBRImageZooms);
  // BR_Custom Product Details Drawer
  BRSafeInit(InitBRProductDetailsDrawer);
});

function BRSafeInit(init) {
  try {
    init();
  } catch (error) {
    console.error("[BR Product] " + init.name + " a échoué", error);
  }
}

function OpenFirstProductTab() {
  setTimeout(() => {
    $(".click_on_ready").trigger("click");
  }, 10);
}

// BR_Custom Color Swatches Names + Material/Price swap on sibling hover
function InitLinkedColorSwatches() {
  $(".custom-color-selector").each(function () {
    const $selector = $(this);
    const $legendValue = $selector
      .find('.radio__legend [translate="no"]')
      .first();
    const $checkedInput = $selector.find(".swatch__input:checked").first();

    if (!$legendValue.length || !$checkedInput.length) return;

    const currentColor = $checkedInput.val();
    const $product = $selector.closest("[data-product]");
    const $materialEl = $product.find("[data-product-material]").first();
    const $priceEl = $product.find("[data-product-price]").first();
    const $comparePriceEl = $product.find("[data-compare-price]").first();

    function storeOriginal($el, attr) {
      if ($el.length && $el.data(attr) === undefined) {
        $el.data(attr, {
          html: $el.html(),
          hidden: $el.attr("hidden") !== undefined,
          isSale: $el.hasClass("product__price--sale"),
        });
      }
    }

    storeOriginal($materialEl, "brOriginal");
    storeOriginal($priceEl, "brOriginal");
    storeOriginal($comparePriceEl, "brOriginal");

    function swapMaterialAndPrice(trigger) {
      const material = trigger.getAttribute("data-sibling-material") || "";
      const price = trigger.getAttribute("data-sibling-price") || "";
      const comparePrice =
        trigger.getAttribute("data-sibling-compare-price") || "";
      const isSale = trigger.getAttribute("data-sibling-sale") === "true";

      if ($materialEl.length) {
        if (material) {
          $materialEl.text(material).removeAttr("hidden");
        } else {
          $materialEl.attr("hidden", "");
        }
      }

      if ($priceEl.length) {
        $priceEl.text(price);
        $priceEl.toggleClass("product__price--sale", isSale);
      }

      if ($comparePriceEl.length) {
        $comparePriceEl.text(comparePrice);
      }
    }

    function resetMaterialAndPrice() {
      [$materialEl, $priceEl, $comparePriceEl].forEach(($el) => {
        if (!$el.length) return;
        const original = $el.data("brOriginal");
        if (!original) return;

        $el.html(original.html);

        if ($el === $materialEl) {
          if (original.hidden) {
            $el.attr("hidden", "");
          } else {
            $el.removeAttr("hidden");
          }
        }

        if ($el === $priceEl) {
          $el.toggleClass("product__price--sale", original.isSale);
        }
      });
    }

    // BR_Custom : swap material/price au hover désactivé
    // (swapMaterialAndPrice / resetMaterialAndPrice restent définies plus haut,
    // prêtes à être réactivées en dé-commentant les 2 lignes ci-dessous)
    const BR_ENABLE_SIBLING_MATERIAL_PRICE_SWAP = false;

    $selector
      .find(".swatch__label[data-swatch]")
      .on("mouseenter focus", function () {
        $legendValue.text($(this).data("swatch"));

        if (BR_ENABLE_SIBLING_MATERIAL_PRICE_SWAP && this.tagName === "A") {
          swapMaterialAndPrice(this);
        }
      })
      .on("mouseleave blur", function () {
        $legendValue.text(currentColor);

        if (BR_ENABLE_SIBLING_MATERIAL_PRICE_SWAP && this.tagName === "A") {
          resetMaterialAndPrice();
        }
      });
  });
}

// BR_Custom Carrousel Medias
function InitBRProductGalleries(container = document) {
  $(container)
    .find("[data-br-product-gallery]")
    .addBack("[data-br-product-gallery]")
    .each(function () {
      const gallery = this;

      if (gallery.dataset.brGalleryInitialized === "true") return;

      const mainElement = gallery.querySelector("[data-br-gallery-main]");
      const thumbsElement = gallery.querySelector("[data-br-gallery-thumbs]");
      const progress = gallery.querySelector("[data-br-gallery-progress]");
      const progressBar = gallery.querySelector(
        "[data-br-gallery-progress-bar]",
      );

      if (!mainElement || typeof Swiper === "undefined") return;

      gallery.dataset.brGalleryInitialized = "true";

      let mainSwiper = null;
      let activeIndex = 0;

      const mobileMediaQuery = window.matchMedia("(max-width: 999px)");
      // BR_Custom : même détection "tablette portrait" que le CSS, pour que le JS
      const tabletPortraitMediaQuery = window.matchMedia(
        "(hover: none) and (pointer: coarse) and (min-width: 600px) and (max-width: 1050px) and (orientation: portrait)",
      );
      const isCompactGallery = () =>
        mobileMediaQuery.matches || tabletPortraitMediaQuery.matches;

      const updateProgress = (swiper) => {
        if (!progress || !progressBar) return;

        // BR_Custom : trait de largeur fixe qui se déplace le long de la piste
        // (comme une scrollbar), plutôt qu'une barre qui se remplit
        const totalSlides = swiper.slides.length;
        const currentIndex = swiper.realIndex;

        const widthPercent = Math.max(100 / totalSlides, 15); // 15% mini pour rester visible
        const maxLeft = 100 - widthPercent;
        const leftPercent =
          totalSlides > 1 ? (currentIndex / (totalSlides - 1)) * maxLeft : 0;

        progressBar.style.width = `${widthPercent}%`;
        progressBar.style.left = `${leftPercent}%`;

        progress.setAttribute("aria-valuemax", totalSlides);
        progress.setAttribute("aria-valuenow", currentIndex + 1);
      };

      const pauseInactiveMedia = (swiper) => {
        swiper.slides.forEach((slide, index) => {
          if (index === swiper.activeIndex) return;

          slide.querySelectorAll("video").forEach((video) => {
            video.pause();
          });

          slide.querySelectorAll("product-model").forEach((model) => {
            if (typeof model.pause === "function") model.pause();
          });
        });
      };

      const destroyGallery = () => {
        if (mainSwiper && !mainSwiper.destroyed) {
          activeIndex = mainSwiper.realIndex;
          mainSwiper.destroy(true, true);
        }

        mainSwiper = null;
      };

      function updateActiveThumb(swiper) {
        if (!thumbsElement) return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        const mediaId = activeSlide ? activeSlide.dataset.mediaId : null;

        thumbsElement
          .querySelectorAll(".br-product-gallery__thumb")
          .forEach((thumb) => {
            thumb.classList.toggle(
              "swiper-slide-thumb-active",
              thumb.dataset.mediaId === mediaId,
            );
          });
      }

      const createGallery = () => {
        const isMobile = isCompactGallery();

        mainSwiper = new Swiper(mainElement, {
          initialSlide: activeIndex,
          direction: isMobile ? "horizontal" : "vertical",
          slidesPerView: 1,
          spaceBetween: 0,
          speed: isMobile ? 300 : 400,
          threshold: 4,
          autoHeight: false,
          cssMode: isMobile,
          mousewheel: isMobile
            ? false
            : {
                releaseOnEdges: true,
                thresholdDelta: 6,
                thresholdTime: 200,
              },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          on: {
            init(swiper) {
              updateProgress(swiper);
              pauseInactiveMedia(swiper);
              updateActiveThumb(swiper);
            },
            slideChange(swiper) {
              activeIndex = swiper.realIndex;
              updateProgress(swiper);
              pauseInactiveMedia(swiper);
              updateActiveThumb(swiper);
            },
          },
        });
      };

      if (thumbsElement) {
        thumbsElement.addEventListener("click", (event) => {
          const thumb = event.target.closest(".br-product-gallery__thumb");
          if (!thumb || !mainSwiper) return;

          const index = Array.from(mainSwiper.slides).findIndex(
            (slide) => slide.dataset.mediaId === thumb.dataset.mediaId,
          );

          if (index > -1) mainSwiper.slideTo(index);
        });
      }

      function layoutThumbsColumns() {
        if (!thumbsElement) return;
        // BR_Custom : on se base sur le display réellement appliqué (CSS) plutôt que sur
        // mobileMediaQuery, pour que ça marche aussi sur tablette portrait (où le CSS
        // réaffiche les thumbs en grille desktop) sans toucher au comportement mobile/desktop.
        if (getComputedStyle(thumbsElement).display === "none") return;

        const thumbs = thumbsElement.querySelectorAll(
          ".br-product-gallery__thumb",
        );
        const thumbCount = thumbs.length;
        if (!thumbCount) return;

        const wrapper = thumbsElement.querySelector(".swiper-wrapper");
        // BR_Custom : on mesure la hauteur du wrapper lui-même, pas de thumbsElement —
        // ce dernier inclut le padding-bottom (zone de respiration volontaire sous les
        // vignettes), qui ne doit jamais être comptée comme espace disponible pour le contenu.
        const availableHeight = wrapper.clientHeight;
        const thumbWidth = thumbs[0].getBoundingClientRect().width;
        const rowHeight = thumbWidth * (61 / 49);
        const gap = parseFloat(getComputedStyle(wrapper).rowGap || 0);

        const maxRowsSingleColumn = Math.max(
          1,
          Math.floor((availableHeight + gap) / (rowHeight + gap)),
        );

        // BR_Custom : seuil 1 vs 2 colonnes — si tout tient sur une seule
        // colonne dans la hauteur disponible, rester à 1 col - Au-delà, bascule à 2 cols
        const columns = thumbCount <= maxRowsSingleColumn ? 1 : 2;
        const rows = Math.ceil(thumbCount / columns);

        thumbsElement.style.setProperty("--br-thumb-columns", columns);
        thumbsElement.style.setProperty("--br-thumb-rows", rows);
      }

      if (thumbsElement) {
        layoutThumbsColumns();
        window.addEventListener("resize", () => {
          layoutThumbsColumns();
        });
      }

      createGallery();

      // BR_Custom : smooth swiper transition → scroll page after last image
      // Without it, releaseOnEdges renders native scroll instatanely on wheel event
      // Intercept first event to smooth scrollBy then leave
      let edgeTransitionLock = false;
      let pastEdgeSince = null; // timestamp du 1er wheel event au-delà du bord
      const EDGE_HOLD_MS = 220; // pause avant d'autoriser le scroll de la page

      gallery.addEventListener(
        "wheel",
        (event) => {
          if (!mainSwiper || mobileMediaQuery.matches) return;

          const goingPastEnd = mainSwiper.isEnd && event.deltaY > 0;
          const goingPastStart = mainSwiper.isBeginning && event.deltaY < 0;

          if (!goingPastEnd && !goingPastStart) {
            edgeTransitionLock = false;
            pastEdgeSince = null;
            return;
          }

          if (edgeTransitionLock) return;

          // BR_Custom : on absorbe le 1er wheel event au-delà du bord sans
          // rien faire, pour laisser un instant de pause avant d'autoriser
          // le scroll de la page — évite que ça parte trop vite dès la
          // dernière image.
          event.preventDefault();

          if (pastEdgeSince === null) {
            pastEdgeSince = event.timeStamp;
            return;
          }

          if (event.timeStamp - pastEdgeSince < EDGE_HOLD_MS) return;

          edgeTransitionLock = true;
          pastEdgeSince = null;
          window.scrollBy({ top: event.deltaY, behavior: "smooth" });

          setTimeout(() => {
            edgeTransitionLock = false;
          }, 350);
        },
        { passive: false },
      );

      mobileMediaQuery.addEventListener("change", () => {
        destroyGallery();
        createGallery();
      });
      tabletPortraitMediaQuery.addEventListener("change", () => {
        destroyGallery();
        createGallery();
      });
    });
}

// BR_Custom Image Zoom Box (markup : snippet br-product-zoom.liquid)
function InitBRImageZooms() {
  $(document)
    .off("click.brProductZoom", "[data-br-product-zoom]")
    .on("click.brProductZoom", "[data-br-product-zoom]", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const clickedLink = this;
      const gallerySlide = clickedLink.closest(".br-product-gallery__slide");
      const mediaId = gallerySlide ? gallerySlide.dataset.mediaId : "";
      const product = clickedLink.closest("[data-product]");
      const dialog =
        (product && product.querySelector("[data-br-zoom]")) ||
        document.querySelector("[data-br-zoom]");

      if (!dialog) {
        console.error(
          "[BR Zoom] <dialog data-br-zoom> introuvable : vérifier le render 'br-zoom-product' dans product.liquid",
          { product },
        );
        return;
      }

      if (typeof dialog.showModal !== "function") {
        console.error("[BR Zoom] <dialog> non supporté par ce navigateur");
        return;
      }

      OpenBRProductZoom(dialog, mediaId, clickedLink);
    });
}

document.addEventListener("shopify:section:load", function (event) {
  InitBRProductGalleries(event.target);
});

// BR_Custom Zoom box : ouvre le <dialog> du snippet br-product-zoom.liquid
// sur l'image cliquée (retrouvée grâce à son media id).
function OpenBRProductZoom(dialog, mediaId, opener) {
  if (dialog.open) return;

  // Les écouteurs ne sont posés qu'une seule fois par dialog
  const zoom = dialog.brZoom || SetupBRProductZoom(dialog);
  zoom.open(mediaId, opener);
}

function SetupBRProductZoom(dialog) {
  const root = document.documentElement;
  const body = document.body;
  const scroller = dialog.querySelector("[data-br-zoom-scroller]");
  const slides = Array.from(dialog.querySelectorAll("[data-br-zoom-slide]"));
  const pages = Array.from(dialog.querySelectorAll("[data-br-zoom-page]"));

  let opener = null;
  let previousOverflow = { root: "", body: "" };

  const scrollToSlide = (index, smooth) => {
    const slide = slides[index];
    if (!slide) return;

    const top =
      slide.getBoundingClientRect().top -
      scroller.getBoundingClientRect().top +
      scroller.scrollTop;

    scroller.scrollTo({ top, behavior: smooth ? "smooth" : "instant" });
  };

  const setActive = (index) => {
    pages.forEach((button, i) => {
      const isActive = i === index;
      button.classList.toggle("is-active", isActive);

      if (isActive) {
        button.setAttribute("aria-current", "true");
      } else {
        button.removeAttribute("aria-current");
      }
    });
  };

  // L'image active = celle qui traverse l'écran
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(slides.indexOf(entry.target));
          }
        });
      },
      { root: scroller, rootMargin: "-50% 0px -50% 0px", threshold: 0 },
    );

    slides.forEach((slide) => observer.observe(slide));
  }

  // Clic sur un numéro = scroll ; clic ailleurs = fermer (comme un "zoom out")
  dialog.addEventListener("click", (event) => {
    const page = event.target.closest("[data-br-zoom-page]");

    if (page) {
      scrollToSlide(Number(page.dataset.brZoomPage), true);
      return;
    }

    dialog.close();
  });

  // Évite que le carrousel Swiper derrière change d'image avec les flèches
  dialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.stopPropagation();
    }
  });

  // Fermeture (clic, bouton, Échap) : on rend le scroll à la page
  dialog.addEventListener("close", () => {
    root.style.overflow = previousOverflow.root;
    body.style.overflow = previousOverflow.body;

    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  });

  dialog.brZoom = {
    open(mediaId, newOpener) {
      opener = newOpener;

      const index = Math.max(
        0,
        slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId)),
      );

      // L'image cliquée se charge tout de suite (les autres restent en lazy)
      const image = slides[index] && slides[index].querySelector("img");
      if (image) image.loading = "eager";

      // Blocage du scroll de la page (sans la faire sauter)
      previousOverflow = {
        root: root.style.overflow,
        body: body.style.overflow,
      };
      root.style.overflow = "hidden";
      body.style.overflow = "hidden";

      dialog.showModal();
      setActive(index);
      scrollToSlide(index, false);
      scroller.focus({ preventScroll: true });
    },
  };

  return dialog.brZoom;
}

// BR_Custom Size Chart (désormais rendu comme accordéon dans le drawer, cf product-size-chart.liquid)
// Le contenu vit dans un <template> jusqu'au clic : il n'existe dans le DOM qu'une fois cloné dans
// le drawer par InitBRProductDetailsDrawer (createDrawer), qui appelle InitBRSizeChartContent($scope)
// juste après le clonage. Toutes les fonctions sont donc SCOPÉES (2e argument $scope, document par
// défaut) pour ne jamais toucher un ancien clone déjà retiré du DOM à la fermeture du drawer.
function InitBRSizeChartContent($scope) {
  SetUpAllCell($scope);
  ActivateDscButtons($scope);
}

function SetUpAllCell($scope) {
  $scope = $scope || document;
  $(".dsc-cell", $scope).each(function () {
    SetUpCell($(this), GetDscSizeActive($scope), $scope);
  });
}

function SetUpCell($cell, sizeActive, $scope) {
  let dscCellValue = UseInch($scope)
    ? $cell.data("inch-size-" + sizeActive)
    : $cell.data("size-" + sizeActive);
  let unit = UseInch($scope) ? '"' : "cm";
  $cell.find(".dsc-cell-to-complete").text(dscCellValue);
  $cell.find(".unit").text(unit);
}

function ActivateDscButtons($scope) {
  $scope = $scope || document;

  $(".dsc-btn-size", $scope)
    .off("click.brDsc")
    .on("click.brDsc", function () {
      $(".dsc-btn-size.active", $scope).removeClass("active");
      $(this).addClass("active");
      SetUpAllCell($scope);
    });

  $(".dsc-btn-inch-cm", $scope)
    .off("click.brDsc")
    .on("click.brDsc", function () {
      $(".dsc-btn-inch-cm.active", $scope).removeClass("active");
      $(this).addClass("active");
      SetUpAllCell($scope);
    });
}

function GetDscSizeActive($scope) {
  return $(".dsc-btn-size.active", $scope || document).data("size");
}

function UseInch($scope) {
  return $("#dsc-btn-inch", $scope || document).hasClass("active")
    ? true
    : false;
}

// BR_Custom Product Details Drawer
function InitBRProductDetailsDrawer() {
  if (window.brProductDetailsDrawerInitialized) return;
  window.brProductDetailsDrawerInitialized = true;

  let active = null;
  let drawerCounter = 0;
  const mobileMediaQuery = window.matchMedia("(max-width: 999px)");

  function setOpen(trigger, open) {
    const panel = trigger
      .closest("[data-br-accordion]")
      .querySelector(".product__accordion__content");

    trigger.setAttribute("aria-expanded", String(open));
    panel.hidden = !open;
  }

  function lockScroll() {
    const scroll = {
      x: window.scrollX,
      y: window.scrollY,
      styles: [],
    };

    const save = (el, property, value) => {
      scroll.styles.push({
        el,
        property,
        value: el.style.getPropertyValue(property),
        priority: el.style.getPropertyPriority(property),
      });

      el.style.setProperty(property, value, "important");
    };

    save(document.documentElement, "overflow", "hidden");
    save(document.body, "overflow", "hidden");
    save(document.body, "position", "fixed");
    save(document.body, "top", `${-scroll.y}px`);
    save(document.body, "left", `${-scroll.x}px`);
    save(document.body, "width", "100%");

    const header = document.querySelector("[data-site-header]");
    if (header) {
      save(header, "transform", `translateY(${scroll.y}px)`);
    }

    return scroll;
  }

  function restoreScroll(scroll) {
    scroll.styles.forEach(({ el, property, value, priority }) => {
      if (value) {
        el.style.setProperty(property, value, priority);
      } else {
        el.style.removeProperty(property);
      }
    });

    window.scrollTo({
      left: scroll.x,
      top: scroll.y,
      behavior: "instant",
    });
  }

  function createDrawer(scope, opener) {
    const dialog = document.createElement("dialog");
    const panel = document.createElement("div");
    const header = document.createElement("div");
    const title = document.createElement("h2");
    const close = document.createElement("button");
    const body = document.createElement("div");

    dialog.className = "br-product-details-drawer";
    dialog.id = `BRProductDetailsDrawer--${++drawerCounter}`;

    panel.className = "br-product-details-drawer__panel";
    header.className = "br-product-details-drawer__header";

    title.className = "br-product-details-drawer__title";
    title.id = `${dialog.id}--title`;
    title.textContent = opener.dataset.brProductTitle;
    const materialEl = scope.querySelector("[data-product-material]");
    const material =
      materialEl && !materialEl.hidden ? materialEl.textContent.trim() : "";
    if (material) {
      const materialSpan = document.createElement("span");
      materialSpan.className =
        "br-product-details-drawer__title-material text-capitalize";
      materialSpan.textContent = material;
      title.append(" ", materialSpan);
    }

    dialog.setAttribute("aria-labelledby", title.id);

    close.className = "br-product-details-drawer__close";
    close.type = "button";
    close.textContent = opener.dataset.brCloseLabel || "Close";
    close.setAttribute("aria-label", opener.dataset.brCloseLabel || "Close");

    body.className = "br-product-details-drawer__body";

    // BR_Custom : barre de scroll custom (1px), hors du padding du panel
    const scrollbar = document.createElement("div");
    scrollbar.className = "br-product-details-drawer__scrollbar";
    const scrollbarThumb = document.createElement("div");
    scrollbarThumb.className = "br-product-details-drawer__scrollbar-thumb";
    scrollbar.appendChild(scrollbarThumb);

    scope
      .querySelectorAll("[data-br-product-details-template]")
      .forEach((template) => {
        body.appendChild(template.content.cloneNode(true));
      });

    // BR_Custom Size Chart : (ré)active les boutons cm/inch et remplit les cellules,
    // scopé au drawer (chaque ouverture recrée un dialog neuf)
    InitBRSizeChartContent(body);

    // BR_Custom : mise à jour de la barre de scroll custom
    const updateScrollbar = () => {
      const scrollable = body.scrollHeight > body.clientHeight + 1;
      scrollbar.hidden = !scrollable;
      if (!scrollable) return;

      const ratio = body.clientHeight / body.scrollHeight;
      const maxScroll = body.scrollHeight - body.clientHeight;
      const progress = maxScroll > 0 ? body.scrollTop / maxScroll : 0;

      scrollbarThumb.style.height = `${ratio * 100}%`;
      scrollbarThumb.style.top = `${(1 - ratio) * progress * 100}%`;
    };

    body.addEventListener("scroll", updateScrollbar, { passive: true });

    if ("ResizeObserver" in window) {
      new ResizeObserver(updateScrollbar).observe(body);
    } else {
      updateScrollbar();
    }

    header.append(title, close);
    panel.append(header, body, scrollbar);
    dialog.append(panel);
    document.body.append(dialog);

    close.addEventListener("click", () => dialog.close());

    let backdropPressed = false;

    dialog.addEventListener("pointerdown", (event) => {
      backdropPressed = event.target === dialog;
    });

    dialog.addEventListener("click", (event) => {
      if (event.target === dialog && backdropPressed) dialog.close();
      backdropPressed = false;
    });

    // BR_Custom : swipe-down-to-close (mobile) — depuis le header toujours,
    // ou depuis le reste du panel seulement si le body est déjà scrollé en haut
    let touchStartY = null;
    let touchCurrentY = null;
    let isDraggingPanel = false;
    let lastTouchY = null;
    let lastTouchTime = null;
    let dragVelocity = 0;

    const DRAG_CLOSE_DISTANCE = 80; // px
    const DRAG_CLOSE_VELOCITY = 0.5; // px/ms

    panel.addEventListener(
      "touchstart",
      (event) => {
        if (!mobileMediaQuery.matches) return;
        if (event.touches.length !== 1) return;

        const fromHeader = header.contains(event.target);
        if (!fromHeader && body.scrollTop > 0) return;

        const touch = event.touches[0];
        touchStartY = touch.clientY;
        touchCurrentY = touchStartY;
        lastTouchY = touchStartY;
        lastTouchTime = event.timeStamp;
        dragVelocity = 0;
        isDraggingPanel = true;
      },
      { passive: true },
    );

    panel.addEventListener(
      "touchmove",
      (event) => {
        if (!isDraggingPanel) return;

        const touch = event.touches[0];
        touchCurrentY = touch.clientY;
        const deltaY = touchCurrentY - touchStartY;

        if (deltaY <= 0) {
          dialog.style.transition = "";
          dialog.style.transform = "";
          return;
        }

        event.preventDefault();

        const now = event.timeStamp;
        const dt = now - lastTouchTime;
        if (dt > 0) dragVelocity = (touchCurrentY - lastTouchY) / dt;
        lastTouchY = touchCurrentY;
        lastTouchTime = now;

        dialog.style.transition = "none";
        dialog.style.transform = `translateY(${deltaY}px)`;
      },
      { passive: false },
    );

    const endPanelDrag = () => {
      if (!isDraggingPanel) return;
      isDraggingPanel = false;

      const deltaY = Math.max(0, (touchCurrentY ?? touchStartY) - touchStartY);
      const shouldClose =
        deltaY > DRAG_CLOSE_DISTANCE || dragVelocity > DRAG_CLOSE_VELOCITY;

      touchStartY = null;
      touchCurrentY = null;

      if (!shouldClose) {
        dialog.style.transition = "transform 0.25s ease";
        dialog.style.transform = "";
        dialog.addEventListener(
          "transitionend",
          function resetDrag(event) {
            if (event.target !== dialog) return;
            dialog.removeEventListener("transitionend", resetDrag);
            dialog.style.transition = "";
          },
          { once: true },
        );
        return;
      }

      dialog.style.transition = "";
      dialog.style.transform = "";
      dialog.style.opacity = "";
      dialog.close();
    };

    panel.addEventListener("touchend", endPanelDrag);
    panel.addEventListener("touchcancel", endPanelDrag);

    dialog.addEventListener("close", () => {
      if (active?.dialog !== dialog) return;

      const { opener: previousOpener, scroll } = active;
      active = null;

      document.body.classList.remove("br-product-details-open");

      restoreScroll(scroll);

      if (previousOpener.isConnected) {
        previousOpener.removeAttribute("aria-controls");
        previousOpener.focus({ preventScroll: true });
      }

      // BR_Custom : on laisse la transition CSS de fermeture (opacity/transform)
      // jouer avant de retirer le dialog du DOM, sinon la fermeture est instantanée.
      const removeAfterTransition = (event) => {
        if (event.target !== dialog) return;
        dialog.removeEventListener("transitionend", removeAfterTransition);
        dialog.remove();
      };

      dialog.addEventListener("transitionend", removeAfterTransition);

      // Garde-fou si transitionend ne se déclenche pas (ex: transitions désactivées)
      setTimeout(() => {
        dialog.removeEventListener("transitionend", removeAfterTransition);
        if (dialog.isConnected) dialog.remove();
      }, 450);
    });

    return { dialog, body };
  }

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-br-product-details-open]");

    if (opener) {
      if (active) return;

      const scope =
        opener.closest(".product-single__details") ||
        opener.closest(".popup-quick-view__content") ||
        opener.closest(".shopify-section") ||
        document;

      const { dialog, body } = createDrawer(scope, opener);

      const selected = [...body.querySelectorAll("[data-br-accordion]")].find(
        (item) =>
          item.dataset.brAccordion === opener.dataset.brProductDetailsOpen,
      );

      if (!selected) {
        dialog.remove();
        return;
      }

      const selectedTrigger = selected.querySelector(
        "[data-br-accordion-trigger]",
      );

      setOpen(selectedTrigger, true);
      opener.setAttribute("aria-controls", dialog.id);

      active = {
        dialog,
        opener,
        scroll: lockScroll(),
      };

      document.body.classList.add("br-product-details-open");

      dialog.showModal();

      const BR_DRAWER_OPEN_COMFORT_OFFSET = 120; // px de marge

      body.scrollTop = Math.max(
        0,
        selected.getBoundingClientRect().top -
          body.getBoundingClientRect().top +
          body.scrollTop -
          BR_DRAWER_OPEN_COMFORT_OFFSET,
      );

      selectedTrigger.focus({ preventScroll: true });
      return;
    }

    const trigger = event.target.closest("[data-br-accordion-trigger]");

    if (!trigger || !active?.dialog.contains(trigger)) return;

    const open = trigger.getAttribute("aria-expanded") !== "true";

    active.dialog
      .querySelectorAll("[data-br-accordion-trigger]")
      .forEach((other) => {
        if (other !== trigger) setOpen(other, false);
      });

    setOpen(trigger, open);

    const body = active.dialog.querySelector(
      ".br-product-details-drawer__body",
    );

    if (open) {
      const offset =
        trigger.getBoundingClientRect().top - body.getBoundingClientRect().top;

      if (offset < 0) body.scrollTop += offset;
    }
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (active && event.target.contains(active.opener)) active.dialog.close();
  });
}

/* Third Party */
function InitKlaviyo() {
  $(document).on("click", ".klaviyo-bis-trigger", function () {
    changeHeadIframe();
  });
}

function changeHeadIframe() {
  if (
    document.getElementById("klaviyo-bis-iframe") === null ||
    document.getElementById("klaviyo-bis-iframe") === "undefined"
  ) {
    setTimeout(changeHeadIframe, 1);
  } else {
    var klaviyoIFrameOutOfStock =
      document.getElementById("klaviyo-bis-iframe").contentWindow.document.head;

    if (
      klaviyoIFrameOutOfStock.innerHTML == "" ||
      klaviyoIFrameOutOfStock.innerHTML == null
    ) {
      setTimeout(changeHeadIframe, 1);
    } else {
      /* Set the style */
      var styles =
        "h3 {display: block;font-family: Abadi MT STD Bold,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight: 500;margin: 0 0 48px;font-size: 13px !important;line-height: 1.4;} .klaviyo-bis-close { background: none!important;}";

      styles +=
        '#klaviyo-bis-modal > #container { border-radius: 0; border: 1px solid #000; margin-top: 50%;font-family: "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;font: 500 14px "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif!important;}';

      styles +=
        'select {font-weight: 500;border: 1px solid black!important; max-width: 100%; padding: 8px 10px!important; border-radius: 0px!important; height: unset!important; appearance: none; background-image: url(https://cdn.shopify.com/s/files/1/0500/2235/1014/t/16/assets/ico-select.svg?v=18273679090726958689)!important;background-repeat: no-repeat!important;background-position: calc(100% - 7px) center!important;background-size: 16px!important;background-color: transparent!important;padding-right: 28px!important;text-indent: 0.01px;font-family: "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;}';

      styles +=
        "#email {font-weight: 500;height: unset;border: 1px solid black!important;max-width: 100%;padding: 8px 10px!important;border-radius: 0px!important;}";

      styles +=
        "p {display: block;font-family: Abadi MT STD Bold,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight: 500;font-size: 1em;line-height: 1.4; padding: 20px 0 20px;}";

      styles +=
        '.close {top: 25px; right: 35px;font-size: 25px!important;font-weight: normal;color: #000!important;text-shadow: 0 0px 0 #fff;font-family: "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;}';

      styles +=
        'button {font-size: 13px!important;font: 500 14px "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif!important;}';

      styles += ".small-print {padding: unset;} ::placeholder {color: #000;}";

      styles += `
        @font-face {
          font-family: "BR Abadi";
          src: url("https://baserange.com/cdn/shop/t/39/assets/AbadiMTStd-Bold.woff?v=131741100073947991811719487625") format("woff");
          font-style: normal;
          font-weight: 400 700;
          font-display: swap;
        }
        #klaviyo-bis-modal,
        #klaviyo-bis-modal * {
          font-family: "BR Abadi", Helvetica, Arial, sans-serif !important;
        }
      `;

      var css = document.createElement("style");
      css.type = "text/css";
      css.appendChild(document.createTextNode(styles));
      klaviyoIFrameOutOfStock.append(css);
    }
  }
}
